export default __webpack_public_path__ + "media/zurb/img/legacy/plunk/about-2-share-3d65aa0af1971fd2476b6abe4d05b5bc.jpg";